import barba from '@barba/core';
import type { IView } from '@barba/core';
import { IdleQueue } from 'idlize/IdleQueue.mjs';
import pageAnimations from '../animations/pages/news-detail/init-page-animations';
import handleContentVideos from '../inits/pages/news-detail/handle-content-videos';
import headerCartHandlers from '@/inits/components/header/header-cart-handlers';
import newsDetailHandlers from '@/inits/pages/news-detail/news-detail-handlers';
import textPageContentHandler from '@/inits/components/common/text-page-content-handler';
import parallaxImages from '../inits/parallax-images';



const beforeEnterQueue = new IdleQueue();

export default {
    namespace: 'news-detail-page',

    beforeEnter() {
        beforeEnterQueue.pushTask(() => {
            pageAnimations.init();
            headerCartHandlers.initForPage();
            newsDetailHandlers.init();
            textPageContentHandler.init();
            parallaxImages.init();
        });
    },

    beforeLeave() {
        handleContentVideos.destroy();
        newsDetailHandlers.destroy();
        parallaxImages.destroy();
        headerCartHandlers.destroyForPage();
    },
} as IView;
